import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/HomeView.vue')
  },
  {
    path: '/concessionaria/:codigo',
    name: 'form',
    component: () => import( '../views/FormView.vue')
  },
  {
    path: '/contratos/:codigo',
    name: 'contratos',
    component: () => import( '../views/TabelaContratos.vue'),
    beforeEnter: (to, from, next) => {
      const token = to.query.token;
      const validToken = process.env.VUE_APP_SOURCE_TOKEN;

      if (token && token === validToken) {
        next();
      } else {
        // Redirect to home if token is missing or invalid
        // Optionally redirect to specific URL or external site
        next('/');
      }
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
